import * as React from 'react'
import { Link } from 'react-router-dom'
import { usePermissions } from '../hooks/usePermissions'

interface Props {
  style?: React.CSSProperties
  productId?: number
}

const ProductLink: React.FC<Props> = ({ productId, children, style = {} }) => {
  const { permissions } = usePermissions()
  if (!productId || !permissions.includes('products.view')) return <>{children}</>

  return (
    <Link style={style} to={`/products/${productId}`}>
      {children}
    </Link>
  )
}

export default ProductLink
